import { render, staticRenderFns } from "./articleDetail.vue?vue&type=template&id=7a44da9f&scoped=true&"
import script from "./articleDetail.vue?vue&type=script&lang=js&"
export * from "./articleDetail.vue?vue&type=script&lang=js&"
import style0 from "./articleDetail.vue?vue&type=style&index=0&id=7a44da9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a44da9f",
  null
  
)

export default component.exports